import React from 'react'
import LoaderImg from 'shared/components/LoaderImg/LoaderImg'
import list from './ListRow.module.scss'

function ListRow({
	leading = null,
	title,
	titleBadge = null,
	subtitle = null,
	subtitleIcon = null,
	trailing = null,
	onRowClick = null,
	isLoading = false,
	className = '',
}) {
	const rowClassName = [
		list.row,
		leading ? list['row--leading'] : '',
		trailing ? list['row--trailing'] : '',
		onRowClick ? list['row--actionable'] : '',
		isLoading ? list['row--loading'] : '',
		className,
	]
		.filter(Boolean)
		.join(' ')

	const content = (
		<>
			{!isLoading && leading ? (
				<div className={list.leading}>{leading}</div>
			) : null}
			<div className={list.main}>
				<div className={list.title}>
					{isLoading ? (
						<span className={list.skeleton}>
							<LoaderImg />
						</span>
					) : (
						<>
							<span className={list.titleText}>{title}</span>
							{titleBadge}
						</>
					)}
				</div>
				{subtitle !== null ? (
					<div className={list.subtitle}>
						{isLoading ? (
							<span className={list.skeleton}>
								<LoaderImg />
							</span>
						) : (
							<>
								{subtitleIcon}
								<span className={list.subtitleText}>{subtitle}</span>
							</>
						)}
					</div>
				) : null}
			</div>
			{trailing ? <div className={list.trailing}>{trailing}</div> : null}
		</>
	)

	if (onRowClick && !isLoading) {
		return (
			<button type="button" className={rowClassName} onClick={onRowClick}>
				{content}
			</button>
		)
	}

	return <div className={rowClassName}>{content}</div>
}

export default ListRow
